export const BYPASS_PATHS = ['/login', '/signup', '/auth/callback'] as const;

/** How long a first-time visitor waits for the maintenance answer before the site is shown anyway. */
export const MAINTENANCE_FIRST_ANSWER_MS = 1500;
